import styled from "styled-components";

const Root = styled.div`
	cursor: pointer;
`;

export default Root;
